export default "__VITE_ASSET__DjUZoHhW__"